import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import ContactForm from "./components/ContactForm";

const features = [
  { icon: "ri-layout-grid-line", title: "分类浏览", desc: "按电影、电视剧分类快速查找影视作品" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "支持地区、年代、评分与类型多条件筛选" },
  { icon: "ri-newspaper-line", title: "资讯速览", desc: "最新行业动态、剧集资讯与影评推荐" },
  { icon: "ri-bookmark-3-line", title: "主题专题", desc: "编辑精选的影视内容合集，发现好作品" },
];

export default function AboutPage() {
  useDocumentMeta({
    title: "关于我们 - 国语对白做受69 影视资源与影视资讯平台",
    description:
      "了解国语对白做受69的网站定位、服务宗旨与联系方式。我们致力于为影视爱好者提供清晰舒适的影视资源浏览与资讯阅读体验。",
    keywords: "关于我们,国语对白做受69,影视平台,影视资讯,联系方式",
  });

  return (
    <Layout>
      <section className="w-full bg-primary-950 text-background-50">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14">
          <nav className="text-xs md:text-sm text-background-400 mb-4 flex items-center gap-1.5">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-400">关于我们</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-bold font-heading">关于我们</h1>
          <p className="mt-3 text-sm md:text-base text-background-300 max-w-2xl leading-relaxed">
            国语对白做受69 是一个面向影视爱好者的资源展示与资讯平台，专注于把电影、电视剧等丰富的影视内容
            更清晰、更舒适地呈现在你面前。
          </p>
        </div>
      </section>

      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16 space-y-14 md:space-y-20">
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">网站定位</h2>
            <div className="mt-4 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                我们围绕“影视资源展示”与“影视资讯发布”两大主题，为用户提供电影、电视剧的分类浏览、
                详情查看以及最新资讯推送，服务对象是喜爱国语影视作品的观众，包括电影迷、剧迷以及关注影视动态的用户。
              </p>
              <p>
                我们希望帮助用户更高效地查找影视作品信息、浏览影视分类与筛选结果、查看剧情简介与主创信息，
                并通过相关推荐与主题专题，减少选择成本，提升影视选择效率。
              </p>
              <p>
                本站为纯展示与浏览性质的内容平台，不提供播放、下载与购买服务；站内搜索、筛选与推荐均为前端演示，
                数据为静态模拟，非实时数据。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {features.map((item) => (
              <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 mb-3">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 md:gap-12 items-start">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">联系我们</h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              如果你对本站有任何建议、内容反馈或合作意向，欢迎通过下方留言表单与我们联系。我们会认真阅读每一条留言，
              并在合适的时候作出回应。
            </p>
            <ul className="mt-5 space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-mail-line"></i>
                </span>
                contact@guoyu69-demo.com（演示邮箱）
              </li>
              <li className="flex items-center gap-2.5">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                  <i className="ri-time-line"></i>
                </span>
                留言将在工作日统一查看
              </li>
            </ul>
          </div>

          <ContactForm />
        </section>

        <section className="rounded-lg bg-background-100 border border-background-200 p-6 md:p-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">版权声明与免责条款</h2>
          <div className="mt-4 space-y-3 text-sm text-foreground-600 leading-relaxed">
            <p>
              本站所展示的影视名称、简介、主创信息等内容仅用于产品功能演示与学习交流，相关文字与图片均为示意，
              不代表任何真实作品的官方信息。
            </p>
            <p>
              本站不存储、不提供任何影视播放与下载资源，不对第三方内容的准确性作出保证。若相关内容涉及权益问题，
              请通过上方留言表单与我们联系，我们将及时处理。
            </p>
            <p>© 2026 国语对白做受69 · 影视资源与影视资讯平台 · 本站内容仅供浏览参考。</p>
          </div>
        </section>
      </div>
    </Layout>
  );
}